import { Box, Stack } from '@mantine/core';
import React from 'react';
import AnalystChatBody from './ChatBody';
import ChatHeader from './ChatHeader';

const Chat: React.FC<{}> = ({}) => {
    return (
        <Stack className="relative flex h-screen w-full flex-col items-center gap-0 overflow-hidden">
            <Box className="sticky top-0 z-30 w-full flex-shrink-0 bg-white/95 backdrop-blur supports-[backdrop-filter]:backdrop-blur">
                <ChatHeader />
            </Box>

            <AnalystChatBody />
        </Stack>
    );
};

export default React.memo(Chat);
